export const getMsgRatesList = (builder) => ({
    getMsgRatesList: builder.mutation({
      query: ({ comm_type, pageNumber, limit, user_type, search, startDate, endDate }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/assigned_route_details',
          method: 'GET',
          params: { comm_type, pageNumber, limit, user_type, search, startDate, endDate },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  